// Generated by `npm run data:roi-feeding` (scripts/data/roiFeeding.ts): the roi's daily ration, from
// Birkeland and Dierking's captive feeding log, data/roi-hcri-0002172/. Do not edit by hand.
// tests/roi.test.ts builds it again.

/** The weight of food a kilogram of roi eats a day, kg: 10 tanks' 120 meals to satiation over 34 days, 4.0490 kg of roi of 23.0 to 30.8 cm, at 26.6 to 28.8 °C (Oʻahu, June and July 2004). */
export const ROI_RATION_PER_DAY = 0.0116259;
